(function (app) {

    app.constant("fundingSources",
    [
        { Label: "Annuity", Value: "Annuity", WorkflowId: 3 },
        { Label: "Bonds", Value: "Bonds", WorkflowId: 1 },
        { Label: "Brokerage Account", Value: "BrokerageAccount", WorkflowId: 1 },
        { Label: "CD", Value: "Cd", WorkflowId: 2 },
        { Label: "Checking/Savings", Value: "CheckingSavings", WorkflowId: 4 },
        { Label: "Life Insurance", Value: "LifeInsurance", WorkflowId: 3 },
        { Label: "Money Market", Value: "MoneyMarket", WorkflowId: 2 },
        { Label: "Mutual Funds", Value: "MutualFunds", WorkflowId: 1 },
        { Label: "Qualified Retirement Plan", Value: "QualifiedRetirementPlan", WorkflowId: 5 },
        { Label: "Stocks", Value: "Stocks", WorkflowId: 1 },
        { Label: "Other", Value: "Other", WorkflowId: 6 }
    ]);
})(window.app); //jshint ignore:line